import { useContext } from 'react';

import { GlobalEvaluationsContext } from 'src/context';

/**
 * Returns the global/module-level evaluations context.
 *
 * Use this for actions that are NOT scoped to a resource instance. For
 * instance-scoped permissions (e.g. a specific ApplicationList or Tenant UUID)
 * use `useInstanceEvaluations` instead.
 */
export const useGlobalEvaluations = () => {
  const context = useContext(GlobalEvaluationsContext);

  /* istanbul ignore if -- @preserve */
  if (!context) {
    throw new Error(
      'useGlobalEvaluations must be used within GlobalEvaluationsProvider',
    );
  }

  return context;
};
